module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-lg-5 px-md-4 px-1",
    attrs: {
      "id": "app"
    }
  }, [_c('rd-samoobsluha-header'), _vm._v(" "), (_vm.$store.state.customerInfo) ? _c('rd-samoobsluha-navbar') : _vm._e(), _vm._v(" "), (_vm.$store.state.newMacDetected) ? _c('section', {
    staticClass: "alert alert-warning upozorneni-pro-zakaznika"
  }, [(_vm.$store.state.customerInfo) ? _c('div', [_c('p', [_vm._v("\n        Vážený zákazníku, zaznamenali jsme připojení k síti Rychlý drát z nové, dozatím neregistrované MAC adresy "), _c('mark', {
    staticClass: "text-monospace"
  }, [_vm._v(_vm._s(_vm.$store.state.newMacDetected))]), _vm._v(".\n        Pro přístup na internet je třeba "), _c('b', [_vm._v("novou (změněnou) MAC adresu registrovat")]), _vm._v(". Změna je bezplatná a projeví se do 15 minut.\n      ")]), _vm._v(" "), (_vm.$router.currentRoute.name !== 'my-net-devices') ? _c('p', {
    staticClass: "d-flex justify-content-between mt-4 mb-2"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.$router.push('/devices')
      }
    }
  }, [_vm._v("chci zaregistrovat novou MAC adresu")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-danger",
    on: {
      "click": function($event) {
        _vm.$store.commit('newMacDetected', false)
      }
    }
  }, [_vm._v("nedělat nic")])]) : _vm._e()]) : _c('div', [_c('p', [_vm._v("\n        Vážený zákazníku, zaznamenali jsme připojení k síti Rychlý drát z nové, dozatím neregistrované MAC adresy "), _c('mark', {
    staticClass: "text-monospace"
  }, [_vm._v(_vm._s(_vm.$store.state.newMacDetected))]), _vm._v(".\n        Pro přístup na internet je třeba "), _c('b', [_vm._v("novou (změněnou) MAC adresu registrovat")]), _vm._v(". Změna je bezplatná a projeví se do 15 minut.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Pro bezpečnost Vašich dat je nutné nejprve se přihlásit.\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.customerInfo && _vm.$store.state.cashTotals.overdue_amount > 0 && _vm.$router.currentRoute.name !== 'payment-finished') ? _c('section', {
    staticClass: "alert alert-danger upozorneni-pro-zakaznika"
  }, [_c('p', [_vm._v("\n      Dobrý den,\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      vážíme si toho, že jste naším zákazníkem. Věříme, že došlo k nedopatření – na Vašem zákaznickém účtu evidujeme pohledávku po splatnosti.\n    ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Nedoplatek: " + _vm._s(_vm.prachy_bez_00(_vm.$store.state.cashTotals.overdue_amount)) + " Kč")])]), _vm._v(" "), _c('p', [_vm._v("\n      Rádi bychom Vás požádali o kontrolu Vámi provedených plateb. Zkontrolujte si prosím i platební symboly (číslo účtu "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v("344355366")]), _vm._v(", kód banky "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v("2010")]), _vm._v(", variabilní symbol "), _c('span', {
    staticClass: "mutable"
  }, [_vm._v(_vm._s(_vm.$store.state.customerInfo.id))]), _vm._v(").\n      Pokud jste již platbu provedli dříve, informujte nás prosím o detailech provedené platby\n      zasláním e-mailu na "), _c('a', {
    attrs: {
      "href": ("mailto:fakturace@rychlydrat.cz?subject=kontrola nedoplatku " + (_vm.prachy_bez_00(_vm.$store.state.cashTotals.overdue_amount)) + " Kč, zákazník VS=" + (_vm.$store.state.customerInfo.id))
    }
  }, [_vm._v("fakturace@rychlydrat.cz")]), _vm._v(".\n    ")]), _vm._v(" "), (_vm.$router.currentRoute.name !== 'my-account') ? _c('p', [_vm._v("\n      Předpisy plateb a evidované přijaté platby si můžete kdykoliv zkontrolovat "), _c('router-link', {
    attrs: {
      "to": "/account"
    }
  }, [_vm._v("na stránce MŮJ ÚČET")]), _vm._v(".\n    ")], 1) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("\n      Rychlý drát, s.r.o.\n    ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.maintenanceMode === true) ? _c('section', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.maintenanceMode === false) ? _c('section', [_c('router-view', {
    on: {
      "after-login": function($event) {
        _vm.afterLogin()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "width-hack"
    }
  }, [_vm._v("\n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n                                         \n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media alert alert-warning p-5"
  }, [_c('img', {
    staticClass: "mr-5",
    attrs: {
      "src": "/static/rd-images/maintenance.png",
      "width": "200px",
      "height": "200px",
      "alt": "probíhá údržba"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "mt-0"
  }, [_vm._v("Probíhá údržba")]), _vm._v("\n          Samoobsluha není v tuto chvíli dostupná. Právě pracujeme na údržbě systému. Zkuste to prosím za chvíli znovu.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-facd4de8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 333
// module chunks = 1 2